import React, { useMemo } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { formatCurrencyToNumber } from '@/utils';
import { useTranslation } from 'react-i18next';

interface IPropsInputCurrency extends NumericFormatProps {
  err?: boolean;
  placeholder?: string;
  coinPrice?: string;
}

export const InputCurrency: React.FC<IPropsInputCurrency> = ({ err, coinPrice, ...rest }) => {
  const { t } = useTranslation();

  const renderClass = () => {
    if (err === undefined) return '';
    return err ? 'error' : 'success';
  };

  const isShowError = useMemo(() => {
    const valueCoin = formatCurrencyToNumber(String(rest.value)) ?? 0;

    return rest.value && coinPrice && Number(rest.value) > 0 && Math.round(valueCoin * Number(coinPrice)) < 20;
  }, [rest.value, coinPrice]);

  return (
    <div className="input-top-trading">
      <NumericFormat {...rest} allowLeadingZeros thousandSeparator="," className={`input-number ${renderClass()}`} />
      {(!rest.value || isShowError || !err) && (
        <div className="input-top-trading__des">
          <span className={`${isShowError && 'input-top-trading__des-error'}`}>
            {t('Withdrawal value must be at least 20 USDT')}
          </span>
        </div>
      )}
    </div>
  );
};

export default InputCurrency;
